<script>
  import makeChart from '../baseChartWidget'
  import chart from './chart'

  export default makeChart('program-spend-wdg-cmp', chart)
</script>



// WEBPACK FOOTER //
// src/components/_modules/Dashboard/widgets/ProgramBudget/index.vue